import React from 'react';
import InlineEditBase from './InlineEditBase';
import Select from '../Select';

interface Option {
  value: string;
  label: string;
}

interface InlineEditSelectProps {
  value: string | undefined;
  onSave: (value: string | number) => Promise<void> | void;
  onCancel?: () => void;
  options: Option[];
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  label?: string;
  showEditButton?: boolean;
}

const InlineEditSelect: React.FC<InlineEditSelectProps> = ({
  value,
  onSave,
  onCancel,
  options,
  disabled = false,
  className = '',
  placeholder,
  label,
  showEditButton = true,
}) => {
  const selectedOption = options.find((opt) => opt.value === value);

  return (
    <InlineEditBase
      value={value}
      onSave={(val) => onSave(typeof val === 'string' ? val : String(val))}
      onCancel={onCancel}
      disabled={disabled}
      className={className}
      showEditButton={showEditButton}
    >
      {({ isEditing, value: editValue, onChange, onSave, onCancel, inputRef }) => {
        if (!isEditing) {
          return (
            <div className="inline-flex items-center">
              <span className="font-medium">
                {selectedOption?.label || value || <span className="text-[var(--color-neutral-400)] italic">Not set</span>}
              </span>
            </div>
          );
        }

        return (
          <div className="animate-slide-down">
            {label && <label className="block text-sm font-medium text-[var(--color-default-font)] mb-1">{label}</label>}
            <select
              ref={inputRef as React.RefObject<HTMLSelectElement>}
              value={editValue.toString()}
              onChange={(e) => onChange(e.target.value)}
              className="w-full px-3 py-2 border border-[var(--color-neutral-border)] rounded-md bg-[var(--color-default-background)] text-[var(--color-default-font)] focus:outline-none focus:ring-2 focus:ring-[var(--color-brand-500)]"
            >
              {placeholder && <option value="">{placeholder}</option>}
              {options.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        );
      }}
    </InlineEditBase>
  );
};

export default InlineEditSelect;

